import type { DataSourceEventPayload } from '@splunk/dashboard-types';
import { _ } from '@splunk/ui-utils/i18n';
import { DS_STATUS } from '@splunk/datasource-utils';

export default function getStatusMessage(dataSource?: DataSourceEventPayload) {
    if (!dataSource) {
        return undefined;
    }
    if (
        dataSource.meta?.status === DS_STATUS.DONE &&
        dataSource.meta?.totalCount === 0
    ) {
        return _('No search results returned');
    }
    if (dataSource.error) {
        return dataSource.error.message;
    }
    return (
        dataSource.meta?.statusMessage ||
        dataSource.meta?.serverLog?.[0]?.message
    );
}
